import React, { FC, useEffect, useRef } from 'react'
import { Box, Fab, makeStyles } from '@material-ui/core'
import { useIntersection } from 'react-use'
import { BUSINESS_DETAILS_SUBMIT_ID } from '../../../../constants'
import { scrollToParagraph } from './helpers'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles((theme) => ({
  scrollBtn: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#F5F5F5',
    fontSize: 42,
    '&:hover': {
      backgroundColor: '#000000',
      color: '#FFFFFF',
    },
  },
}))

export const ScrollDownButton: FC = () => {
  const classes = useStyles()
  const observeEl = useRef<HTMLElement | null>(null)
  const intersection = useIntersection(observeEl, { threshold: 0.1 })

  const businessDetailsNode = document.getElementById(BUSINESS_DETAILS_SUBMIT_ID)

  useEffect(() => {
    if (businessDetailsNode) {
      observeEl.current = businessDetailsNode
    }
  }, [businessDetailsNode])

  return (
    <Box
      position="fixed"
      bottom={56}
      width={140}
      display={intersection?.isIntersecting ? 'none' : 'flex'}
      justifyContent={'center'}
    >
      <Fab className={classes.scrollBtn} onClick={scrollToParagraph(BUSINESS_DETAILS_SUBMIT_ID)}>
        <ExpandMoreIcon color={'inherit'} fontSize={'inherit'} />
      </Fab>
    </Box>
  )
}
